
import React, { useEffect } from "react";
import { Table, Space } from "antd";
import strings from "../../utils/strings";
import EditInsuranceWage from "./EditInsuranceWage";
import { usePersistedStore } from "../../store/persisted-store";
import { useGeneralStore } from "../../store/slices/createGeneralSlice";

export default function InsuranceDefaultWages({insuranceWagesId}) {

    const general = useGeneralStore();
    const { business, getDefaultAgentWage, getDefaultAgentWagePerId } = usePersistedStore()
    const defaultAgentWages = business.businesses.defaultAgentWage;
    const defaultAgentWagesLoading = business.businesses.loading;
    const token = business?.currentBusiness?.token;
    
    useEffect(() => {
        if (token || insuranceWagesId === 1)
            getDefaultAgentWage();
    }, [token]);

    const columns = [
        {
            title: "رشته بیمه",
            dataIndex: "InsuranceBranchName",
            key: "InsuranceBranchName",
            ellipsis: true,
            render: (text) => <span style={{ color: "#5ec393" }}>{text}</span>
        },
        {
            title: "درصد کارمزد",
            dataIndex: "DefaultAgentWagePercent",
            key: "DefaultAgentWagePercent",
            render: (text) => text && <span style={{ color: "#f00000" }}>{strings.getFarsiNum(text)} %</span>
        },
        {
            title: "مبلغ کارمزد",
            dataIndex: "DefaultAgentWagePrice",
            key: "DefaultAgentWagePrice",
            render: (text) => text && <span style={{ color: "#f00000" }}>{strings.currencyFormat(text)} ريال</span>,
        },
        {
            title: "",
            dataIndex: "operation",
            key: "operation",
            ellipsis: true,
            render: (_, record) =>
                defaultAgentWages.length > 0 && (
                    <Space size="middle">
                        <button type="link" className="btn btn-primary btn-sm waves-effect waves-light"
                            onClick={() => {
                                general.ToggleEditInsuranceDefaultAgentModal();
                                getDefaultAgentWagePerId(record.InsuranceBranchId);
                            }}>
                            <i className="fas fa-edit font-size-16 align-middle mr-2"></i> ویرایش
                        </button>
                    </Space>
                ),
        },
    ];

    return (
        <div>
            <Table
                style={{ overflowX: 'scroll' }}
                className="custom-table"
                scroll={true}
                bordered
                columns={columns}
                loading={defaultAgentWagesLoading}
                rowKey="InsuranceBranchId"
                dataSource={defaultAgentWages}
            />
            <EditInsuranceWage />
        </div>
    )

}